import React from 'react';
import { CardHeader } from '../../shared/card/card-header';
import './card-clients.scss';
export var CardClientDownloadsHeader = function () {
    return (React.createElement(CardHeader, null,
        React.createElement("header", { className: "c-card__header" },
            React.createElement("div", { className: "c-card__header__top" },
                React.createElement("div", { className: "c-card__header__applicant" },
                    React.createElement("h3", null, "Documents"))))));
};
